<template>
    <div class="c-iframe">
        <iframe
            v-if="isModalOpen"
            width="800"
            height="450"
            :src="videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script setup>
import { watch, computed } from "vue";

const props = defineProps({
    isModalOpen: {
        type: Boolean,
        required: true,
    },
    videoId: {
        type: String,
        required: true,
    },
});

const videoUrl = computed(() => `https://www.youtube.com/embed/${props.videoId}?autoplay=1`);

const stopVideo = () => {
    const iframe = document.querySelector(".c-iframe iframe");
    if (iframe) {
        iframe.src = "";
    }
};

watch(
    () => props.isModalOpen,
    (newVal) => {
        if (!newVal) {
            stopVideo();
        }
    }
);
</script>
